export const Currencies = {
  USD: 'USD',
  AUD: 'AUD',
  TWD: 'TWD',
  BND: 'BND',
  MYR: 'MYR',
  IDR: 'IDR',
  KRW: 'KRW',
  THB: 'THB',
  CNY: 'CNY',
  JPY: 'JPY',
  BDT: 'BDT',
  MOP: 'MOP',
  VND: 'VND',
  INR: 'INR',
  GBP: 'GBP',
  NZD: 'NZD',
  SAR: 'SAR',
  PHP: 'PHP',
  SGD: 'SGD',
  HKD: 'HKD',
  EUR: 'EUR',
};
